import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { loginAsync, logoutAsync, clearError } from '@store/slices/authSlice';
import type { LoginCredentials } from '@appTypes/auth.types';

export function useAuth() {
  const dispatch = useAppDispatch();
  const { user, tokens, isAuthenticated, isLoading, error } = useAppSelector(
    (state) => state.auth,
  );

  const login = useCallback(
    (credentials: LoginCredentials) => dispatch(loginAsync(credentials)).unwrap(),
    [dispatch],
  );

  const logout = useCallback(() => dispatch(logoutAsync()), [dispatch]);

  const dismissError = useCallback(() => dispatch(clearError()), [dispatch]);

  return {
    user,
    tokens,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    dismissError,
  };
}
